export * from './tage-list.component';
export * from './tage-list.component.module';
